@if (!erreurRecuperation()) {
  <div>
    <app-liste-generique [proprietesAffichees]="proprietesAfficheesTemplates" [listeObjets]="tabFichiers()"
    (clicObjetEvent)="showConfirmSuppr($event)"></app-liste-generique>
    <button class="btn btn-primary" onclick="document.getElementById('fileInput').click();"><i class="fas fa-plus" style="padding-right: 5px;"></i>{{'GLOBAL.AJOUTER' | translate}}</button>
    <input type="file" accept=".xlsx" id="fileInput" style="display:none;" (change)="fileFromInput($event)" />
  </div>
}
@if (erreurRecuperation()) {
  <div class="custom-alert custom-alert-sm">
    {{'GLOBAL.ERREUR_RECUP_DONNEES' | translate }}
  </div>
}

<div bsModal #modalSuppr="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="custom-overlay"></div>
      <div class="modal-body text-center">
        <p>{{'GLOBAL.SUPPRIMER' | translate}}</p>
        <button type="button" class="btn btn-primary" (click)="delete()">{{'GLOBAL.OUI' | translate}}</button>
        <button type="button" class="btn btn-secondary" (click)="hideConfirmSuppr()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
      </div>
    </div>
  </div>
</div>
